const enTranslation = {
  // Common
  app_name: 'Fortune Teller',
  home: 'Home',
  login: 'Login',
  back: 'Back',
  next: 'Next',
  submit: 'Submit',
  cancel: 'Cancel',
  required: 'Required',
  cat_saju: 'K-fortuen',
  // Main Page
  fortune_categories: 'Fortune Categories',
  best_items: 'Best Items',
  all_categories: 'All Categories',
  favorites: 'Favorites',
  history: 'History',
  my_page: 'My Page',
  tarot_new: 'New Tarot Release!',
  tarot_desc: 'Authentic tarot reading including reversed cards',
  
  // Categories
  cat_reunion: 'Reunion',
  cat_marriage: 'Marriage',
  cat_love: 'Love',
  cat_compatibility: 'Compatibility',
  cat_newyear: 'New Year',
  cat_career: 'Career',
  cat_trial: 'Trial Reading',
  cat_free: 'Free Trial',
  cat_wealth: 'Wealth',
  cat_tarot: 'Tarot',
  cat_tarot_love: 'Tarot Love',
  cat_tarot_future: 'Tarot Future',
  cat_tarot_career: 'Tarot Career',
  best_items_saju: 'Best Items',
  best_items_tarot: 'Best Tarot Items',
  
  // Product Titles
  product_reunion_title: 'Can I meet that person again?',
  product_compatibility_title: 'Dating, marriage, and deep compatibility?',
  product_marriage_title: 'When will I get married?',
  product_love_title: 'What is my love fortune?',
  product_newyear_title: 'What will the new year bring?',
  product_career_title: 'What is my career fortune?',
  product_wealth_title: 'How is my wealth fortune?',
  product_tarot_love_title: 'Tarot reading for your love',
  product_tarot_future_title: 'Tarot reading for your future',
  product_tarot_career_title: 'Tarot reading for your career',
  
  // Product Detail Page
  product_detail_title: 'Product Detail - Fortune Teller',
  original_price: 'Original Price',
  discount_rate: 'Discount',
  final_price: 'Price',
  buy_now: 'Buy Now',
  product_details: 'Product Details',
  reviews: 'Reviews',
  product_includes: 'This reading includes:',
  product_not_found: 'Product not found',
  all_rights_reserved: 'All rights reserved',
  
  // Product Descriptions
  product_reunion_desc: 'Through your birth chart, we will examine the possibility of reunion with that person. We will analyze when and how you might reunite with your ex-lover, old friend, or someone you cannot forget.',
  product_marriage_desc: 'We will analyze your marriage timing and potential partner through your birth chart. We will tell you when you might get married, the characteristics of your spouse, and the nature of your married life.',
  product_love_desc: 'We will analyze your love fortune and relationships through your birth chart. We will tell you about your current relationship, when new relationships might come, and your ideal partner type.',
  product_compatibility_desc: 'We will analyze your compatibility with that person through both birth charts. We will tell you about your love compatibility, marriage compatibility, and hidden compatibility.',
  product_newyear_desc: 'We will analyze your overall fortune for 2025 through your birth chart. We will tell you about your financial fortune, health fortune, business fortune, and important timing.',
  product_career_desc: 'We will analyze your career aptitude, success timing, and favorable periods for promotion or job change through your birth chart.',
  product_wealth_desc: 'We will analyze your wealth fortune through your birth chart. We will tell you when your income might increase, when to be careful with spending, and favorable timing and areas for investment.',
  
  // Birth Input Page
  birth_info_title: 'Enter Your Birth Information',
  birth_info_desc: 'Please enter your birth date and time for accurate reading.',
  birth_date: 'Birth Date',
  birth_year: 'Year',
  birth_month: 'Month',
  birth_day: 'Day',
  birth_time: 'Birth Time',
  unknown_time: 'Unknown Time',
  partner_info: 'Partner Information',
  partner_birth_date: 'Partner\'s Birth Date',
  
  // Comment Input Page
  concern_title: 'Special Event',
  concern_desc: 'Please share your concern or question (optional)',
  concern_placeholder: 'Enter your concern or question here...',
  char_count: 'characters',
  
  // Payment Page
  payment_title: 'Payment',
  payment_desc: 'Only 19,900 won!',
  product_name: 'Product Name',
  product_price: 'Product Price',
  coupon: 'Coupon',
  total_payment: 'Total Payment',
  max_discount: 'Maximum discount applied',
  coupon_change: 'Change Coupon',
  payment_method: 'Payment Method',
  card_payment: 'Credit Card',
  bank_transfer: 'Bank Transfer',
  agree_terms: 'I agree to the terms of service',
  proceed_payment: 'Pay Now',
  
  // Result Page
  result_title: 'Your Fortune Result',
  result_desc: 'Based on your birth information, here is your fortune reading.',
  
  // Login Page
  login_with_google: 'Login with Google',
  login_desc: 'Login to save your readings and get personalized recommendations.',
  
  // Validation Messages
  validate_birth_date: 'Please enter your complete birth date.',
  validate_birth_time: 'Please enter birth time or check "Unknown Time".',
  validate_partner_birth: 'Please enter your partner\'s complete birth date.'
};

export default enTranslation;
